import { Button, Group, Modal } from "@mantine/core";
import { IconAlertTriangleFilled } from "@tabler/icons-react";
import { ModalFooter } from "../../../../../mantine/components/ModalFooter/ModalFooter";

interface ParticipationWarningModalProps {
  onSubmit: () => Promise<void>;
  onCancel: () => void;
}

function ParticipationWarningModal({
  onSubmit,
  onCancel
}: ParticipationWarningModalProps) {
  return (
    <Modal
      className="ParticipationWarningModal"
      opened
      title={
        <Group gap="sm">
          <IconAlertTriangleFilled
            color="var(--mantine-color-warning-filled)"
            size={16}
          />
          Änderung übernehmen?
        </Group>
      }
      onClose={onCancel}
    >
      <p>
        Sie haben eine Änderung im Feld „Teilnahme am Mieterstrom“ vorgenommen.
        Wenn Sie diese Änderung speichern, erstellt opti.node ein neues Mess-und
        Bilanzierungskonzept für Sie. Dies kann bis zu zwei Tage in Anspruch
        nehmen. In dieser Zeit kann opti.node keine Rechnungen für Sie
        erstellen.
      </p>
      <p>
        Bitte stellen Sie außerdem sicher, dass Ihr Messstellenbetreiber den
        angepassten Lastgang an opti.node schickt.
      </p>
      <ModalFooter>
        <Button variant="default" onClick={onCancel}>
          Abbrechen
        </Button>
        <Button color="warning" onClick={onSubmit}>
          Ja, übernehmen
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { ParticipationWarningModal };
